exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.hoverR:hover {\n\tcolor: #007cc3 !important;\n}\n.img-height {\n\tmin-height: 200.19px;\n}\n.border-radius {\n\tborder-radius: 2px;\n}\n", ""]);

